import './StepProgress.scss';

interface Step {
    label: string;
    date: string;
    srcImg: string;
    completed: boolean;
    type: string; 
}
interface Props {
    steps: any[];
    rtl: boolean;
    width?: string;
}

function StepProgress({ rtl, steps }: Props) {

    return (
        <div className={rtl ? `TO__StepContainer TO__StepRight` : `TO__StepContainer`}>
            {steps.map((step: any, index: number) => {

                return (
                    <div key={`{step.label}-${index}`} className={`TO__StepItem ${step.completed ? 'completed' : ''}`}>
                        <img src={step.srcImg} className="TO__StepCounter" alt='step-circle' />
                        <div className={`TO__StepName ${step.type}`}>
                            {step.label}
                        </div>
                        <p className={`TO__Date ${step.type}`}>{step.date}</p>
                    </div>
                )
            })}
        </div>
    )
}

export default StepProgress;